import { type TLabelVariant } from '@macarongfactory/web-ui'

/** NOW 카테고리명 → Label variant 매핑 (미정의 카테고리는 neutral) */
const NOW_CATEGORY_LABEL_VARIANT: Record<string, TLabelVariant> = {
  이벤트: 'brand',
  게임: 'informative',
  설문: 'caution',
  기타: 'neutral',
}

export const getNowCategoryLabelVariant = (
  categoryName: string
): TLabelVariant => NOW_CATEGORY_LABEL_VARIANT[categoryName] ?? 'neutral'

/** ISO date-time → "YY.MM.DD" (TZ 보정 없이 날짜 부분만 사용) */
const formatNowDate = (isoDateTime: string): string => {
  const [year, month, day] = isoDateTime.slice(0, 10).split('-')
  return `${year.slice(2)}.${month}.${day}`
}

/** 프로모션 기간 → "26.04.25 ~ 26.05.01" (시작/종료 모두 있을 때만) */
export const formatNowPromotionPeriod = (
  start?: string | null,
  end?: string | null
): string | null => {
  if (!start || !end) return null
  return `${formatNowDate(start)} ~ ${formatNowDate(end)}`
}
